export default "__VITE_ASSET__DSrOJrUo__"